export enum LoginModeEnum {
  host = 'host',
  guest = 'guest',
}
